import { render, staticRenderFns } from "./gsm.vue?vue&type=template&id=48cf7e40&scoped=true"
import script from "./gsm.vue?vue&type=script&lang=js"
export * from "./gsm.vue?vue&type=script&lang=js"
import style0 from "./gsm.vue?vue&type=style&index=0&id=48cf7e40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cf7e40",
  null
  
)

export default component.exports